import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3762300e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "post d-flex flex-column-fluid",
  id: "kt_post"
}
const _hoisted_2 = {
  id: "kt_content_container",
  class: "container-fluid px-0"
}
const _hoisted_3 = { class: "card card-one" }
const _hoisted_4 = { class: "card-header px-5 py-4 border-0 arrow-icon" }
const _hoisted_5 = { class: "card-title px-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left fs-2x" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "d-flex align-items-center position-relative search" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "17.0365",
    y: "15.1223",
    width: "8.15546",
    height: "2",
    rx: "1",
    transform: "rotate(45 17.0365 15.1223)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
    fill: "black"
  })
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "user-title" }
const _hoisted_13 = { class: "card-toolbar" }
const _hoisted_14 = {
  class: "d-flex justify-content-end align-items-center",
  "data-kt-user-table-toolbar": "base"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "las la-sync fs-1 text-primary" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_18 = { class: "d-md-flex d-block" }
const _hoisted_19 = { class: "w-100 mb-3" }
const _hoisted_20 = {
  key: 0,
  id: "demo",
  class: "w-100 w-md-50 w-lg-25 ms-md-5 collapse no-transition"
}
const _hoisted_21 = { class: "w-100 list-boxes p-5 border-dashed border-1 border-primary rounded" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "border-bottom mb-2 pb-3 text-gray-800" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-35px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-layers fs-2x text-primary" })
  ])
], -1))
const _hoisted_25 = {
  class: "scroll-y me-n5 pe-3 dual-list list-left col-sm-12 px-0 mh-600px",
  id: "kt_explore_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#vz_detail_drawer__body",
  "data-kt-scroll-dependencies": "#vz_detail_drawer__header",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_26 = { class: "well text-right" }
const _hoisted_27 = { class: "list-group border-0" }
const _hoisted_28 = { class: "d-flex align-items-center position-relative m-4" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "17.0365",
    y: "15.1223",
    width: "8.15546",
    height: "2",
    rx: "1",
    transform: "rotate(45 17.0365 15.1223)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
    fill: "black"
  })
], -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = { id: "draggable-events" }
const _hoisted_33 = ["id"]
const _hoisted_34 = { class: "d-flex align-items-center bg-light-info rounded p-4" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-layers fs-2x me-3 text-primary" }, null, -1))
const _hoisted_36 = { class: "flex-grow-1 me-2" }
const _hoisted_37 = ["id"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted d-block" }, null, -1))
const _hoisted_39 = { class: "list-arrows" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye fs-6" }, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "engage-toolbar d-flex position-fixed px-5 fw-bolder zindex-2 top-50 end-0 transform-90 mt-20 gap-2" }
const _hoisted_44 = {
  href: "#demo",
  class: "engage-demos-toggle btn btn-flex h-35px bg-body btn-color-gray-700 btn-active-color-gray-900 shadow fs-6 px-4 rounded-top-0",
  "data-bs-toggle": "collapse"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vz_filter = _resolveComponent("vz-filter")!
  const _component_FullCalendar = _resolveComponent("FullCalendar")!
  const _component_vz_add_schedule = _resolveComponent("vz-add-schedule")!
  const _component_FormDetailModal = _resolveComponent("FormDetailModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("a", {
                class: "btn btn-icon btn-active-color-primary",
                href: "javascript:;",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'taskscheduler' })), ["stop"]))
              }, _hoisted_7),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refresh())),
                  class: "svg-icon svg-icon-1 position-absolute ms-3"
                }, _hoisted_10),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.searchFilter && _ctx.searchFilter(...args))),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchTermEvent) = $event)),
                  "data-kt-user-table-filter": "search",
                  class: "form-control w-md-350px ps-13",
                  placeholder: _ctx.t('common.search')
                }, null, 40, _hoisted_11), [
                  [_vModelText, _ctx.searchTermEvent]
                ])
              ])
            ]),
            _createElementVNode("h1", _hoisted_12, _toDisplayString(_ctx.userTitle), 1),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args))),
                  type: "button",
                  class: "btn bg-transparent position-relative pe-0"
                }, _hoisted_16),
                _createVNode(_component_vz_filter, {
                  options: _ctx.scheduleFilter,
                  defaultFilter: {},
                  viewName: "scheduleFilter",
                  onFilterChange: _ctx.applyFilter
                }, null, 8, ["options", "onFilterChange"]),
                (_ctx.hasPermission('VYZOR:APPLICATIONS:SCHEDULER:CREATE'))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-outline btn-outline-primary btn-active-light-primary ms-3",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showModal && _ctx.showModal(...args)))
                    }, [
                      _hoisted_17,
                      _createTextVNode(_toDisplayString(_ctx.t("common.addTask")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["card-body pt-2 px-5", [_ctx.loading && 'overlay overlay-block']])
          }, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_FullCalendar, {
                  class: "min-h-500px",
                  ref: "calendarRef",
                  options: _ctx.calendarOptions
                }, null, 8, ["options"])
              ]),
              (_ctx.hasPermission('VYZOR:APPLICATIONS:SCHEDULER:CREATE'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("h3", _hoisted_23, [
                          _hoisted_24,
                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.forms")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("ul", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("span", {
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchData())),
                                  class: "svg-icon svg-icon-1 position-absolute ms-3 hand-cursor"
                                }, _hoisted_30),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.searchData()), ["enter"])),
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchTerm) = $event)),
                                  "data-kt-user-table-filter": "search",
                                  class: "form-control ps-13 mb-2 mb-sm-0",
                                  placeholder: _ctx.t('common.search')
                                }, null, 40, _hoisted_31), [
                                  [_vModelText, _ctx.searchTerm]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_32, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forms, (form, i) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: i,
                                    class: "list-group-item drop-event",
                                    id: form.webId
                                  }, [
                                    _createElementVNode("div", _hoisted_34, [
                                      _hoisted_35,
                                      _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("span", {
                                          id: form.webId,
                                          ref_for: true,
                                          ref: 'form_' + form.webId,
                                          class: "fw-bolder text-gray-800 text-hover-primary fs-6"
                                        }, _toDisplayString(form.name), 9, _hoisted_37),
                                        _hoisted_38
                                      ]),
                                      _createElementVNode("span", _hoisted_39, [
                                        _createElementVNode("a", {
                                          class: "btn btn-icon btn-light-primary w-30px h-30px bg-transparent",
                                          onClick: _withModifiers(($event: any) => (_ctx.openDetailModal(form.webId)), ["stop"])
                                        }, _hoisted_42, 8, _hoisted_40)
                                      ])
                                    ])
                                  ], 8, _hoisted_33))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ]),
        _createVNode(_component_vz_add_schedule, {
          onSubmit: _ctx.submitData,
          data: _ctx.editData,
          onUpdate: _ctx.updateData,
          modelValue: _ctx.show,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.show) = $event)),
          isEditable: _ctx.isEditable,
          onTaskDelete: _ctx.deleteTask
        }, null, 8, ["onSubmit", "data", "onUpdate", "modelValue", "isEditable", "onTaskDelete"])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("a", _hoisted_44, _toDisplayString(_ctx.t("common.forms")), 1)
      ])
    ]),
    _createVNode(_component_FormDetailModal, {
      viewName: "form_detail_modal",
      data: _ctx.selectedForm,
      showDialog: _ctx.showDetailDialog,
      onCloseDetail: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showDetailDialog = false))
    }, null, 8, ["data", "showDialog"])
  ], 64))
}